import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';

import Iconify from '../../../../components/Iconify';
import { DebounceInput } from 'react-debounce-input';
import { SmallFormTextField } from '../../../../components/small-fields/SmallFormTextField';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';
import { useSelector } from 'react-redux';

export const CommentsDialog = props => {
  const { open, setOpen, node } = props;
  console.log(node);
  const { employeeId } = useSelector(state => state.app);
  const { updateNodeF } = useAccomodationDiagram();
  const [comment, setComment] = React.useState(node?.data?.comment?.message || '');

  const onSubmit = () => {
    const newNode = node;
    newNode.data = {
      ...newNode.data,
      comment: { message: comment, createdAt: new Date(), createdBy: employeeId }
    };
    updateNodeF(node);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle id="add-new-house-dialog">Panel komentarzy {node?.data?.eventName}</DialogTitle>
      <DialogContent>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} mt={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Komentarz</Typography>
          <TextField
            sx={{ flex: '1 1 80%' }}
            type="text"
            placeholder="komentarz"
            value={comment}
            onChange={e => setComment(e.target.value)}
            autoFocus
            multiline
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack>
          <Button
            fullWidth
            variant="contained"
            endIcon={<Iconify icon={'eva:save-fill'} />}
            onClick={onSubmit}
          >
            Zapisz zmiany
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
